import ApplicationController from '../application_controller';
import Rails from "@rails/ujs";

export default class extends ApplicationController {

  static targets = ['searchInput', 'productList', 'count', 'searchFilterForm']

  search(event) {
    event.preventDefault();
    this.setRequestId();
    this.spinnerOn(this.spinnerTarget);
    Rails.fire(this.searchFilterFormTarget, 'submit');
  }

  searchResult(event) {
    event.preventDefault();
    this.spinnerOff(this.spinnerTarget)
    if (this.requestId == event.detail[0].body.querySelector('#request_id').value) {
      this.replaceElementWithNewBySingleQuery('.product-list', event)
      this.pushQueryParamsToUrl(this.searchFilterFormTarget);
      this.searchInputTarget.focus();
    }
  }

  updateAmounts(event){
    let finalAmount = parseInt(this.countTarget.value);
    document.querySelectorAll('p.amount').forEach(element => this.updateAmount(element, finalAmount))
  }

  updateAmount(element, finalAmount){
    element.textContent = (parseInt(element.dataset.amount) * finalAmount).toString();
  }
}
